import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { clientTypes } from "../../../../../Utils/GlobalVariables/Crm/ClientTypes";

const CrmFormStepOne = (props) => {
  const { update } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [clientOriginSelect, setClientOriginSelect] = useState([]);
  const [processGoalSelect, setProcessGoalSelect] = useState([]);
  const clientTypeSelect = clientTypes();
  const [prognosisSelect, setPrognosisSelect] = useState([]);

  const [contacts, setContacts] = useState([]);

  const { values, form } = props;

  const loadData = async (searchTerm) => {
    if (searchTerm?.length > 0) {
      const data = GlobalAuthFetch({
        path: `/contact/findByName/${searchTerm}`,
      });
      const [contactListPayload] = await Promise.all([data]);
      const contactList = contactListPayload?.payload?.data?.map((contact) => {
        return {
          uuid: contact.uuid,
          value: `${contact.name}`,
          ...contact,
        };
      });

      if (contactList?.length > 0) {
        setContacts(contactList);
        return contactList;
      } else {
        setContacts([]);
        return [];
      }
    }
  };

  useEffect(() => {
    form.change("urgent", false);
    const fetchData = async () => {
      const clientOriginFetch = GlobalAuthFetch({
        path: "/dictionary/clientOrigin/fieldName",
      });
      const processGoalFetch = GlobalAuthFetch({
        path: "/dictionary/processGoal/fieldName",
      });
      const prognosisFetch = GlobalAuthFetch({
        path: "/dictionary/prognosis/fieldName",
      });
      const [clientOriginPayload, processGoalPayload, prognosisPayload] =
        await Promise.all([
          clientOriginFetch,
          processGoalFetch,
          prognosisFetch,
        ]);
      setClientOriginSelect(
        clientOriginPayload?.payload?.data.dictionaryEntries
      );
      setProcessGoalSelect(processGoalPayload?.payload?.data.dictionaryEntries);
      setPrognosisSelect(prognosisPayload?.payload?.data.dictionaryEntries);
    };
    fetchData();
  }, []);

  return (
    <div className="CrmFormStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:crm.basicInformation")} />
      <Row>
        <Col xs={12}>
          <Field
            component={BMXAsynchronous}
            label={`${t("global:crm.contractor")}`}
            name="contractor"
            data-cy="contractor"
            options={contacts}
            currentValues={values}
            getOptionLabel={(option) => {
              if (option.name) return option.name;
              return option;
            }}
            getData={loadData}
            afterIcon="add"
            afterIconSize="13px"
            afterIconClick={() => {
              const updateTableRegistry = () =>
                updateDashboardByName("contact");
              dispatch(
                show("ContactsModal", {
                  updateTableRegistry,
                  header: t("global:contacts.add"),
                  loadData,
                })
              );
            }}
          />
        </Col>

        <Col xs={6}>
          <Field
            component={BMXTextField}
            label={`${t("global:crm.fundsPurpose")}`}
            name="fundsPurpose"
            data-cy="fundsPurpose"
          />
        </Col>

        <Col xs={6}>
          <Field
            component={BMXSelectField}
            values={clientTypeSelect?.map((el) => ({
              name: el.name,
              value: el.value,
            }))}
            label={`${t("global:crm.clientType")}*`}
            name="clientType"
            data-cy="clientType"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXSelectField}
            values={processGoalSelect?.map((el) => ({
              name: el.entryName,
              value: el.uuid,
            }))}
            label={`${t("global:crm.processGoal")}*`}
            name="processGoal"
            data-cy="processGoal"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXSelectField}
            values={clientOriginSelect?.map((el) => ({
              name: el.entryName,
              value: el.uuid,
            }))}
            label={`${t("global:crm.clientOrigin")}*`}
            name="clientOrigin"
            data-cy="clientOrigin"
          />
        </Col>

        <Col xs={{ span: 6 }}>
          <Field
            component={BMXSelectField}
            values={prognosisSelect?.map((el) => ({
              name: el.entryName,
              value: el.uuid,
            }))}
            label={`${t("global:crm.prognosis")}`}
            name="prognosis"
            data-cy="prognosis"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field
            name="lead"
            fieldtype="checkbox"
            component={BMXTextField}
            label={t("global:crm.lead")}
          ></Field>
        </Col>
      </Row>
      <Row></Row>
    </div>
  );
};

export default CrmFormStepOne;
